import { CloseIcon } from "@/styles/icons/CloseIcon";
import { getStatus, normalizeGatewayResponses } from "@/utils";
import { Pills } from "barte-design-system";
import { format } from "date-fns";
import { useEffect } from "react";
import { Container } from "./styles";

export interface ChargeTriesProps {
  formattedValue: string;
  errorTransactionalResponse: any;
  errorTimestamp: string;
  expirationDate: string;
  formattedExpirationDate: string;
  status: string;
  uuid: string;
  value: number;
}

interface ErrorModalProps {
  confirmButtonText?: string;
  status: string;
  clientName: string;
  modalState: boolean;
  setModalState: (item: boolean) => void;
  error: ChargeTriesProps;
}

export function ErrorModal({
  confirmButtonText,
  clientName,
  status,
  modalState,
  setModalState,
  error
}: ErrorModalProps) {

  function handleConcludeButton() {
    setModalState(!modalState);
  }

  function handleFilterChargeTryTransactionalError(flag: string): string {
    if (error?.errorTimestamp && flag === "timestamp") {
      const time = new Date(error?.errorTimestamp);
      return format(time, "dd/MM/yyyy hh:mm");
    }
    if (error?.errorTransactionalResponse && "errorReason") {
      if (error?.errorTransactionalResponse?.length === 0) {
        return "Sem dados de erro"
      }
      const { data: arrFormattedJSON } = normalizeGatewayResponses(error?.errorTransactionalResponse[0])
      // @ts-ignore
      const errorNumber = arrFormattedJSON[0]?.error?.codeReason ?? ""
      // @ts-ignore
      const errorReason = arrFormattedJSON[0]?.error?.message ?? ""
      return `${errorNumber} = ${errorReason} (${errorNumber})`
    }
    return "null"
  }

  useEffect(() => {
    handleFilterChargeTryTransactionalError("");
  }, [error?.errorTimestamp]);



  return (
    <Container isOpen={modalState}>

      <div>
        <div className="box">

          <div className="top">
            <p>
              Tentativa de cobrança
            </p>
            <button onClick={handleConcludeButton}>
              <CloseIcon size={11} />
            </button>
          </div>

          <div className="middle">
            <div>
              <div className="client">
                <p>Cliente</p>
                <p>{clientName}</p>
              </div>

              <div >
                <p>Status</p>
                
                <Pills
                  label={getStatus(status)}
                  variant="light"
                  state="error"
                  />
              </div>
            
            </div>
            <div>
              <div className="charge-amount">
                <p>Valor da cobrança</p>
                <p>{error?.formattedValue}</p>
              </div>

            </div>
          </div>

          <div className="try">
            <div >
              <div>
                <p>Data da tentativa</p>
                <p>{handleFilterChargeTryTransactionalError("timestamp")}</p>
              </div>
              <div>
                <p>Informação do erro</p>
                <p>{handleFilterChargeTryTransactionalError("errorReason")}</p>
              </div>
            </div>
          </div>

          <div className="footer">
            <button onClick={handleConcludeButton}>
              {confirmButtonText}
            </button>
          </div>
        </div>
      </div>
    </Container>
  );
}